<template>
  <!-- firmOrder购物车下单/firmOrder1立即下单 -->
  <div v-wechat-title="$route.meta.title">
    <div class="container">
      <div class="topTitle">
        <img @click="goBack" class="backImg" src="../assets/pingzi/back.png" alt="" />
        {{ OrganizationName || "无配送商" }}
      </div>
      <div style="width: 100%;height: 0.8rem;background: transparent;"></div>
      <!-- 经营内容的选择 -->
      <van-popup v-model="jyContent" position="bottom">
        <van-picker
          show-toolbar
          :item-height="44"
          value-key="Text"
          :columns="yxmdObj"
          @cancel="jyContent = false"
          @confirm="onConfirm1"
        />
      </van-popup>
      <div class="customerInfo" v-if="isType==1">
        <div class="">客户:{{customerName}}</div>
        <div class="employee-name">业务员:{{employeeName||''}} {{employeePhone||''}}</div>
      </div>
      <!-- 收货地址-->
      <div>
        <div
          v-if="addName && addAddress"
          @click="toAddress"
          class="addPart disp-just-cen-ali-cen-fldir-col"
          hover-class="btnHover"
        >
          <div class="part disp-just-bet-ali-cen">
            <img class="addImg" src="../assets/icon/shr1.png" />
            <div class="left">
              <div class="flexh">
                <span style="margin-right:0.4rem">{{ addName || "请选择" }}</span>
                <span>{{ addMobile || "请选择" }}</span>
              </div>
              <div class="disp-just-bet-ali-cen">
                <span class="">{{ addAddress || "请选择" }}</span>
              </div>
            </div>
            <img class="right" src="../assets/icon/you.png" />
          </div>
        </div>
      </div>
      <div @click="toAddress" v-if="addId == -1" class="addPart addPart1 disp-just-cen-ali-cen">
        <img src="../assets/pingzi/addp.png" alt="" />添加收货地址
      </div>
      <!-- 
      <div v-if="FirmOrderStore.remark === ''" @click="addRemark" class="addPart addPart1 disp-just-cen-ali-cen">
        <img src="../assets/pingzi/addp.png" alt="" />添加备注
      </div> -->

      <van-field
        v-model="FirmOrderStore.remark"
        @click="addRemark"
        center
        disabled
        label="备注"
        placeholder="请输入备注"
      >
        <template #button>
          <van-button size="small" type="primary">编辑</van-button>
        </template>
      </van-field>

      <van-dialog @confirm="setRemark" v-model="showRemarkEdit" title="编辑备注" @ show-cancel-button>
        <van-field v-model="remark" rows="5" type="textarea" maxlength="200" placeholder="请输入备注" show-word-limit />
      </van-dialog>

      <!-- 商品 -->
      <div class="goodsBox">
        <ul class="list">
          <buy-car-item
            v-for="(item, index) in list"
            :item="item"
            :key="index"
            :enableCheck="false"
            :isAddCart="false"
            :allowChangeActivity="false"
            :enableShowDelete="false"
            :enableTyingProduct="false"
            :wareHouseType="wareHouseType"
            @jia="jia.apply(this, $event)"
            @jian="jian.apply(this, $event)"
            @inputFocus="inputFocus.apply(this, $event)"
            @checkChange="checkChange.apply(this, $event)"
            @showActivityListSheet="showActivityListSheet.apply(this, $event)"
          ></buy-car-item>
        </ul>
      </div>
      <!-- https://carshoph5.51autoshop.com/ -->
      <span v-if="form" style="opacity: 0;position: absolute;bottom:-200rpx;" v-html="form"></span>
      <!-- 底部结算 -->
      <div class="footer flexSpBte">
        <div class="qx color4">共{{ selectArrLength }}件</div>
        <div class="hj">
          <span class="">合计：</span>
          <span class="baseColor2">
            <span class="finalAmount"> ￥{{ finalAmount.toFixed(2) }} </span>
          </span>
        </div>
        <div class="enter bgBaseColor" @click="changePayType">
          <span class="">提交订单</span>
        </div>
      </div>

      <!-- 数量弹窗 -->
      <div class="bianji" v-if="xiugaiShow">
        <div class="box">
          <div class="lists" style="margin-bottom:0.2rem;">
            <span class="">修改购买数量</span>
          </div>
          <div class="storenum" v-if="selectItem.ShoppingCartType != 2">可售库存{{ StoreNum }}</div>
          <div class="modified2 flexSpBte">
            <img class="img" src="../assets/icon/_s-jian@2x.png" @click="lessTap" />
            <input class="num" max="" @input="changeNumber" v-model="changeNum" type="number" />
            <img class="img" src="../assets/icon/_s-jia@2x.png" @click="addTap" />
          </div>
          <div class="btn flexCenter">
            <span class="canlebtn" @click="priceChange">取消</span>
            <span class="sussbtn" @click="priceChangePost(selectItem, changeNum)">确定</span>
          </div>
        </div>
      </div>

      <!-- loading的显示隐藏 -->
      <van-popup :close-on-click-overlay="false" v-model="loadShow">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </van-popup>

      <!-- 确认支付成功的弹框 -->
      <div class="payTypeBox" v-if="surePaySuccess">
        <div class="payType sureWrap">
          <div class="sureText">确认支付成功？</div>
          <div class="sureContent">
            <div @click="closeSurePart" class="sure1 sure">否</div>
            <div @click="changeStatus" class="sure2 sure">是</div>
          </div>
        </div>
      </div>
      <!-- loading的显示隐藏 -->
      <van-popup :close-on-click-overlay="false" v-model="loadShow">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </van-popup>
      <!-- 选择支付方式 -->
      <paytype ref="pay" @paySuccess="paySuccess" @cancelPay="cancelPay"></paytype>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import $ from "../utils/axiosp";
import util from "../utils/util";
import location from "../utils/mapp";
import { Toast } from "vant";
import { RadioGroup, Radio, Dialog } from "vant";
Vue.use(RadioGroup);
Vue.use(Radio);
import { Loading } from "vant";
Vue.use(Loading);

Vue.use(Toast);
import baseUrl from "../utils/basedata.js";
import axiosp from "../utils/axiosp";
import api from "../services/api";
import buyCarItem from "../components/buyCarItem";
import BuyCarStore from "../store/buycar";
import FirmOrderStore from "../store/FirmOrder";
import IndexStore from "../store/Index";
import paytype from "../components/paytype";
Vue.use(Dialog);
import { Field } from "vant";

Vue.use(Field);

export default {
  name: "firm-order",
  components: { buyCarItem, paytype },
  computed: {
    loadShow: {
      get: () => {
        console.log("loadShowChange", FirmOrderStore.loading);
        return FirmOrderStore.loading;
      },
      set: () => {},
    },
    //数量合计
    selectArrLength: () => FirmOrderStore.getSelectedLength(),
    //金额合计
    finalAmount: () => FirmOrderStore.getSelectedAmount(),
  },
  data() {
    return {
      BuyCarStore,
      IndexStore,
      FirmOrderStore, //添加响应式
      remark: "",
      showRemarkEdit: false,
      xiugaiShow: false,
      changeNum: 0,
      selectItem: null,
      StoreNum: null,
      orderActivity: null, //订单活动
      disabledPayCredit: false, //是否有活动
      allinfo: {
        DomainUrl: "",
      },
      ImgUrl: sessionStorage.getItem("PictureDocumentDomainURL"),
      form: "",
      radio: "", //付款方式
      creditMoney: {},
      amount: 0, //总价
      addName: "",
      addAddress: "",
      addMobile: "",
      addId: "",
      OrderId: "",
      index: -1,
      PaymentInformation: "",
      list: [],
      yxmdObj: null,
      isNewUser: null,
      // addflag: false, //控制页面  在show的时候 不获取缓存的地址
      addflag2: true, //控制页面  不能重复点击去收货地址
      // payFlag: true,
      ADS_OrderId: "",
      Pay_Platform: "", //支付平台类型(0:支付宝,1:微信,2:银联)
      OrganizationName: "", //配送商名称
      MallCustomerBelongId: "", //配送商id
      surePaySuccess: false, //确认支付成功与否
      jyContent: false, //配送商
      requstNum: 0, //如果成功，数字在10以内请求，超过不管
      canPayCallBack: false, //可以调起回调
      IsImmediatePurchase: 0,
      wareHouseType:0,
      isType:1,
      employeeName:'',//员工姓名
      employeePhone:'',//员工手机号
      customerName:'', //客户名称
      isSeckill:''
    };
  },
  created: function() {
    window.scrollTo(0,0)
    this.$emit("footer", false);
    let result;
    if (this.$route.path === "/firmOrder") {
      result = 0;
    } else {
      result = 1;
    }

    this.IsImmediatePurchase = result;
    this.wareHouseType = IndexStore.state.wareHouseType;
    console.log('wareHouseType',this.wareHouseType);
    //缓存订单活动
    let orderActivity = sessionStorage.getItem("orderActivity");
    if (orderActivity) {
      this.orderActivity = JSON.parse(orderActivity);
    }
    this.isType = util.getStoObj('urlQuery').IsTypr;
    if(this.isType==1){
      this.customerName = sessionStorage.getItem("CustomerName");
    }
    if(util.getStoObj("allinfo")){
      this.employeeName = sessionStorage.getItem("EmployeeName")||'';
      this.employeePhone = localStorage.getItem("EmployeeMobile")||'';
    }
  },
  updated() {
    if (sessionStorage.getItem("addName") && util.getSto("addflag")) {
      this.addName = sessionStorage.getItem('addName');
      this.addAddress = sessionStorage.getItem('addAdd');
      this.addMobile = sessionStorage.getItem('addMobile');
      this.addId = sessionStorage.getItem('addId');
    }
  },
  methods: {
    goBack(){
      if(this.$route.query.from=='warehouseOut'){
        wx.miniProgram.navigateBack()
      }else{
        this.$router.go(-1)
      }
      
    },
    addRemark() {
      //添加备注
      this.showRemarkEdit = true;
      this.remark = FirmOrderStore.remark;
    },
    setRemark() {
      FirmOrderStore.remark = this.remark;
    },
    priceChangePost(selectItem, num) {
      if (util.checkBuyIpt(num)) {
        util.toast("修改成功");
        selectItem.Num = parseInt(num);
        this.xiugaiShow = false;
      } else {
        util.toast("输入有误");
      }
    },
    changeNumber(e) {
      console.log(e.target.value);
      let number = e.target.value;
      if (number > 100000) {
        this.changeNum = 100000;
        Toast("单次购买不能大于100000个");
      }
      if (number < 0) return (this.changeNum = 1);
    },
    priceChange(e) {
      this.xiugaiShow = !this.xiugaiShow;
    },
    addTap() {
      this.changeNum = Number(this.changeNum) + 1;
      if (this.changeNum > 100000) this.changeNum = 100000;
    },
    lessTap() {
      this.changeNum = Number(this.changeNum) - 1;
      if (this.changeNum <= 0) {
        this.changeNum = 1;
      }
    },
    inputFocus(item) {
      this.changeNum = item.Num;
      this.xiugaiShow = true;
      this.selectItem = item;
      this.StoreNum = item.StoreNum;
    },

    onConfirm1(value) {
      this.OrganizationName = value.Text;
      this.MallCustomerBelongId = value.Id;
      this.jyContent = false;
    },
    goStore() {
      this.$router.push({
        path: "/store",
        query: {},
      });
    },
    cancelPay() {
      console.log("用户取消支付了");
      this.$router.replace(`/orderDetail/${this.orderInfo.salesOrderId ? this.orderInfo.salesOrderId : this.orderInfo.Id}`);
    },
    paySuccess() {
      console.log("支付成功");
      this.$router.replace({
        path: "/paySuccess",
        query: {
          id: this.orderInfo.salesOrderId ? this.orderInfo.salesOrderId : this.orderInfo.Id,
          ordertype: this.orderInfo.OrderType === 20 ? 1 : 2 /**20 销售结算 43销售开单***/,
          type: this.orderInfo.OrderType,
          isSeckill: this.isSeckill,
        },
      });
    },
    // 提交订单
    async changePayType() {
      console.log("changePayType");
      var that = this;
      if (!that.addId || !that.addMobile) {
        if (!that.addMobile) {
          Toast("请先完善收货地址的手机号");
        } else {
          Toast("请选择收货地址");
        }
      } else {
        
        
        let result;
        let WarehouseId = that.list[0].WarehouseId;
        let CustomerId;
        if(this.isType == 1){
          CustomerId = localStorage.getItem("CustomerID")||"";
        }else{
          CustomerId = util.getStoObj("allinfo").UserId;
        }
        let res = await api.getIsCustomerOverdueArrears({
          CustomerId: CustomerId
        });
        if(res.Data == 1){
          return Toast('额度超期不允许下单');
        }
        try {
          //提交订单在此处进行判断
          console.log("VehicleTypeId", IndexStore.state);
          result = await FirmOrderStore.createOrder({
            VehicleTypeId: IndexStore.state.VehicleTypeId,
            WarehouseId: WarehouseId,
            AddressId: this.addId,
            IsType:this.isType
          });
          //Toast("创建成功");

          if (FirmOrderStore.form == "index") {
            IndexStore.selectedAll(false);
          } else if (FirmOrderStore.form == "buycar") {
            BuyCarStore.clearSelected();
          }

        } catch (error) {
          console.error(error);
          Toast(error.toString() || "系统繁忙，请稍后再试。");
        }

        this.loadShow = false;
        if (result) {
          if(this.isType == 1){
            let oid = 0;
            if(result.salesOrderId){
              oid = result.salesOrderId
            }else{
              oid = result.Id
            }
            this.$router.replace({ name: 'orderDetail', params: { id: oid, from:'pay'}})
            return;
          }
          this.$route.meta.title = "支付";
          //显示支付面板
          // that.payTypeShow = true;
          console.log("changePayTypechangePayType"); //创建订单内容
          this.orderInfo = result;
          this.orderInfo.Amount = this.finalAmount;
          var item = this.orderInfo;
          this.$refs.pay.show({
            OrderId: item.Id,
            OrderCode: item.Code,
            OrderType: item.OrderType,
            Amount: item.Amount,
            uiType: "full",
            hideItems: this.disabledPayCredit ? ["limit"] : [], //非活动订单
            enableCoupon: !this.disabledPayCredit, //非活动订单
            Type: result.salesOrderId ? 20 : 63,//如果有值(出库的时候type传20)，结算单，否则：销售开
            Id: result.Id,//出库的时候要传的ID值
          });
        }
      }
    },
    // 去收货地址页面  如果是新用户直接进入新增地址页面  保存后直接返回订单页
    toAddress() {
      // console.log("111");
      // 需要考虑有没有汽配通账户
      // 但是目前强行必须要有汽配通账户

      if (this.addName || this.addAddress) {
        this.$router.push({
          path: "/myAddress",
          query: {
            from: "order",
          },
        });
      } else {
        //无汽配通账户的用户
        this.$router.push({
          path: "/addAddress",
          query: {},
        });
      }
    },
    // 获取默认地址
    getDefaultAdd() {
      this.$parent.Loading(true)
      axiosp
        .reqPost("User/GetUserAddress", {
          UserId: util.getStoObj("allinfo").ADS_UserId,
          GetClass: 1,
        })
        .then((res) => {
          res = res.Data;

          util.setSto("addflag", true);
          if (res.length > 0) {
            this.addName = res[0].Contacts;
            this.addAddress = res[0].CompleteAddress;
            this.addMobile = res[0].Mobile;
            this.addId = res[0].Id;
          }else{
            this.addId = -1
          }
        })
        .then(() => {
          this.Loading = false;
          this.$parent.Loading(false)
        });
    },

    // 处理商品列表
    forMateList() {
      let newArr = [];
      this.list.forEach((item, index) => {
        item.Amount = (item.Price * 10000 * item.Num) / 10000;
        // if (item.check) {
        newArr.push(item);
        // }
      });
      this.list = newArr;
    },
  },
  async mounted() {
    this.$route.meta.title = "确认订单";
    this.allinfo = util.getStoObj("allinfo");
    var that = this;
    that.OrganizationName = IndexStore.state.CompanyName; //配送商名称
    that.MallCustomerBelongId = this.allinfo.MallCustomerBelongs; //配送商名称

    //初始化商品
    // FirmOrderStore.updateList(this.finalList);
    console.log(FirmOrderStore.list.list);
    if(sessionStorage.getItem("warehouseOutData")){
      let _list = JSON.parse(sessionStorage.getItem("warehouseOutData")).list
      _list.forEach((item)=>{
        let url = item.ImgUrl || item.ProdPackURl || "";
        item.ImgUrlOne = this.allinfo.DomainUrl + url.split(",")[0];
      })
      FirmOrderStore.updateList(_list);
    }
    that.list = FirmOrderStore.list.list;
    this.disabledPayCredit = !!this.list.find((it) => {
      return it.type == "pack";
    });

    this.disabledPayCredit = this.disabledPayCredit || this.orderActivity;

    that.getDefaultAdd();
    that.forMateList();
  },
};
</script>

<style scoped lang="scss">
@import "../styles/activityBills.scss";

@import url("../styles/base1.css");
@import url("../styles/blues.css");
.topTitle{
  font-size: 0.28rem
}
.list {
  .li{
    padding: 0.2rem 0.2rem 0.2rem 0.2rem !important;
  }
}
.ms-list {
  li {
    width: 100%;
    height: auto;
    overflow: hidden;
    background: #fff;
    padding: 0.3rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.26rem;
    margin-top: 0.2rem;
    img {
      width: 1.42rem;
      height: 1.42rem;
      background: rgba(240, 240, 240, 1);
      border-radius: 0.04rem;
    }
    .box {
      width: calc(100% - 1.64rem);
      h3 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.1rem;
        div {
          font-size: 0.28rem;
          color: rgba(28, 28, 28, 1);
        }
        span {
          font-size: 0.22rem;
          color: #999;
        }
      }
      .price {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 0.24rem;
        div {
          color: rgba(255, 90, 46, 1);
          font-size: 0.24rem;
          &:first-child {
            margin-right: 0.3rem;
          }
        }
        // font-weight: bold;
      }
    }
  }
}
.customerInfo{
  font-size: 0.28rem;
  padding: 0.15rem 0.2rem 0.15rem 0.2rem;
  justify-content: space-between;
  background: #fff;
  font-weight: bold;
}
.employee-name{
  font-size: 0.24rem;
  font-weight:normal;
  color: #666;
  margin-top: 3px;
}
.container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f6f6f6;
}

// input[type="submit"]{
// 	opacity: 0!important;
// }
/* 支付确认成功 */
.sureWrap {
  top: 4rem !important;
  height: 2.5rem !important;
  width: 90% !important;
  left: 5% !important;
  border-radius: 0.6rem !important;
}

.sureText {
  width: 100%;
  text-align: center;
  font-size: 0.32rem;
  margin: 0.2rem 0;
}

.sureContent {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 20px 0;

  .sure {
    width: 2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    font-size: 0.3rem;
    border-radius: 0.3rem;
  }

  .sure1 {
    color: #4fae54;
    border: 1px solid #4fae54;
    background-color: white;
  }

  .sure2 {
    color: white;
    border: 1px solid white;
    background-color: #4fae54;
  }
}

.baseColor1 {
  font-size: 0.3rem;
  color: #ff5a2e;
  font-weight: bold;

  span {
    font-size: 0.24rem;
  }
}

.baseColor2 {
  font-size: 0.4rem;
  color: #ff5a2e;
  font-weight: bold;

  span {
    font-size: 0.24rem;
  }
}

.addPart1 {
  img {
    width: 0.48rem;
    height: 0.48rem;
  }

  font-size: 0.34rem;
  color: #4fae54;
}

.radios {
  width: 6rem;
  display: flex;
  align-items: center;

  img {
    margin-right: 0.3rem;
  }
}

.companyName {
  // border-radius: 0.2rem;
  font-size: 0.28rem;
  box-sizing: border-box;
  padding: 0.25rem 0.2rem;
  background: #fff;

  img {
    width: 0.68rem;
    height: 0.68rem;
    margin-right: 0.3rem;
    border-radius: 50%;
  }

  .des {
    width: calc(100% - 0.7rem);
    height: 90%;
    display: flex;
    // flex-direction: column;
    justify-content: space-between;
    align-items: left;

    span:nth-child(1) {
      color: #333333;
      font-size: 0.28rem;
      font-weight: bold;
      width: 1.2rem;
      display: flex;
      align-items: center;
    }

    span:nth-child(2) {
      color: #333333;
      width: calc(100% - 1rem);
    }
  }
}

.addPart {
  width: 100%;
  margin-top: 0.2rem;
  box-sizing: border-box;
  background-color: white;
  padding: 0.2rem 0.5rem 0.1rem 0.5rem;

  .part {
    width: 100%;
    // height: 2rem;

    .left {
      width: 78%;
      // height: 2rem;

      div {
        // margin-top: 0.4rem;

        span:nth-child(1) {
          // width: 1.2rem;
          font-size: 0.28rem;
          color: #333333;
          // font-weight: bold;
          // margin-right: 0.4rem;
        }

        span:nth-child(2) {
          font-size: 0.3rem;
          color: #333333;
          // text-align: right;
          // width: calc(100% - 1.5rem);
        }
      }
    }

    .right {
      width: 0.16rem;
      height: 0.25rem;
    }

    .addImg {
      width: 0.68rem;
      height: 0.68rem;
    }
  }
}

.goodsLists {
  width: 100%;
  position: relative;
  margin-top: 0.4rem;
  background: #fff;

  .center {
    margin-left: 0.2rem;
    margin-right: 0.1rem;
    display: flex;

    img {
      width: 2.4rem;
      height: 2.4rem;
      padding: 0.2em;
    }
  }

  .right {
    font-size: 0.28rem;
    display: flex;
    justify-content: space-between;
    align-items: left;
    flex-direction: column;
    flex: 1;
    .bold {
      font-size: 0.3rem;
      color: #1c1c1c;
    }

    .xhKc {
      width: 90%;
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.1rem;
  background: #fff;
  font-size: 0.26rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  .checkBox {
    width: 0.32rem;
    height: 0.32rem;
    background: transparent;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    margin-top: -0.16rem;
    left: 0.3rem;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;

    .check {
      width: 0.2rem;
      height: 0.2rem;
      background: #000;
      border-radius: 50%;
      border: 1px solid #fff;
    }
  }

  .qx {
    margin-left: 0.2rem;
    letter-spacing: 1px;
  }

  .hj {
    margin: 0 0.1rem;
  }

  .enter {
    width: 3rem;
    height: 100%;
    line-height: 1.1rem;
    background: #999;
    color: #fff;
    text-align: center;
    font-size: 0.34rem;
  }
}

.goodsBox {
  margin-bottom: 1rem;
}
.flexh {
  display: flex;
  margin-bottom: 0.2rem;
}
.modified {
  width: 2.18rem;
  height: 0.4rem;
  border: 1px solid rgba(230, 230, 230, 1);
  overflow: hidden;
  border-radius: 4px;
  .flexh {
    align-items: center;
    width: 0.4rem;
    height: 0.4rem;
    justify-content: center;
    margin: 0;
    background: #f0f0f0;
    img {
      width: 0.15rem;
    }
  }
}
.bianji {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  .box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 7rem;
    height: 4rem;
    background: #fff;
    z-index: 11;
    text-align: center;
    font-size: 0.28rem;
    border-radius: 0.12rem;
    margin: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tit {
      margin-bottom: 0.8rem;
    }
    .lists {
      padding: 0.2rem;
      box-sizing: border-box;
      font-size: 0.36rem;
      color: #1c1c1c;
      font-weight: bold;
      margin-bottom: 1.08rem;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      .red {
        color: #e64340;
      }
      .grays {
        color: #888;
      }
    }
    .bobotm {
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
.canlebtn {
  width: 2.05rem;
  height: 0.68rem;
  border: 2px solid rgba(79, 174, 84, 1);
  border-radius: 0.34rem;
  display: inline-block;
  color: rgba(79, 174, 84, 1);
  line-height: 0.68rem;
  font-size: 0.3rem;
  margin-right: 0.3rem;
}
.sussbtn {
  width: 2.05rem;
  height: 0.68rem;
  background: rgba(79, 174, 84, 1);
  border: 2px solid rgba(79, 174, 84, 1);
  border-radius: 0.34rem;
  display: inline-block;
  color: #fff;
  font-size: 0.3rem;
  line-height: 0.68rem;
}
.container {
  margin-bottom: 70px;
}
.bianji {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  .box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 7rem;
    height: 4rem;
    background: #fff;
    z-index: 11;
    text-align: center;
    font-size: 0.28rem;
    border-radius: 0.12rem;
    margin: auto;
    overflow: hidden;
    .tit {
      margin-bottom: 0.8rem;
    }
    .lists {
      padding: 0.2rem;
      box-sizing: border-box;
      font-size: 0.36rem;
      color: #1c1c1c;
      font-weight: bold;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      .red {
        color: #e64340;
      }
      .grays {
        color: #888;
      }
    }
    .bobotm {
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
.modified {
  height: 0.4rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  .img {
    width: 0.4rem;
    padding: 0.06rem;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
  }
  .num {
    display: inline-block;
    vertical-align: top;
    width: 1.4rem;
    font-size: 0.24rem;
    color: #bababa;
    text-align: center;
    background: #f5f5f5;
    height: 0.4rem;
    line-height: 0.4rem;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
  }
}
.modified2 {
  width: 2.4rem;
  height: 0.8rem;
  margin: 0 auto;
  .img {
    width: 0.68rem;
    height: 0.68rem;
    padding: 0.06rem;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
  }
  .num {
    width: 1.2rem;
    display: inline-block;
    vertical-align: top;
    line-height: 0.4rem;
    border: 0.02rem solid #e2e2e2;
    font-size: 0.24rem;
    color: #000;
    text-align: center;
  }
}
</style>
